/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';

// utils
import { cn } from '@repo/zolintra-utils';
// components
import { Icon, availableIcons } from '../Icon/Icon';

import styles from './MessageBanner.module.css';

export function MessageBanner({
  children, color, icon, className,
}) {
  return (
    <div className={cn([styles.banner, styles[color], className])}>
      {icon ? <Icon className={styles.icon} icon={icon} /> : null}
      {children}
    </div>
  );
}

MessageBanner.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['primary', 'success', 'error']),
  icon: PropTypes.oneOf(Object.keys(availableIcons)),
  className: PropTypes.string,
};

MessageBanner.defaultProps = {
  color: 'primary',
  icon: null,
  className: '',
};

export default MessageBanner;
